import { render, staticRenderFns } from "./StyleEditor.vue?vue&type=template&id=8ad86642&scoped=true"
import script from "./StyleEditor.vue?vue&type=script&lang=ts"
export * from "./StyleEditor.vue?vue&type=script&lang=ts"
import style0 from "./StyleEditor.vue?vue&type=style&index=0&id=8ad86642&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad86642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ad86642')) {
      api.createRecord('8ad86642', component.options)
    } else {
      api.reload('8ad86642', component.options)
    }
    module.hot.accept("./StyleEditor.vue?vue&type=template&id=8ad86642&scoped=true", function () {
      api.rerender('8ad86642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/StyleEditor.vue"
export default component.exports